import { Color } from 'services/apiTypes/card.types'
import { CardType } from 'types/deck'

export function getCardsColorIdenty(colors: Color[], card: CardType) {
  colors.push(...card.colorIdentity)

  return [...new Set(colors)]
}
